import { MDBAlert, MDBBtn, MDBModalFooter, MDBSpinner } from 'mdb-react-ui-kit';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { deleteSndRecFax, deleteSndRecGroupFax } from '../../../apiclients/streamsapi_bridge';

function DeleteSntRecFax(props) {
    const [internalError, setInternalError] = useState(false);
    const { t, i18n } = useTranslation();
    const [isloading, setIsloading] = useState(false);
    const navigate = useNavigate();

    async function removeThisFax(e) {
        try {
            e?.preventDefault();
            e?.stopPropagation();
            setInternalError(false);
            setIsloading(true);

            let deleteGrpReponse = null;
            if (props.groupFaxFlag) {
                deleteGrpReponse = await deleteSndRecGroupFax(JSON.parse(sessionStorage.getItem("admin_session")).siteid, props.faxid, 1);
              } else {
                deleteGrpReponse = await deleteSndRecFax(JSON.parse(sessionStorage.getItem("admin_session")).siteid, props.faxid);
              }
            setTimeout(() => { setIsloading(false) }, 1000);
            let delInfo = await deleteGrpReponse.json();

            if (delInfo.status == 'success') {
                props.setSuccessMessage(delInfo.message);
                props.setrerender(true);
                props.onClose();


            } else {
                setInternalError(true);
                props.onClose();
            }
        } catch (e) {
            console.log(`Unable to process Request :Internal server Error:!`);
            setInternalError(true);
        }
    }
    return (
        <>
            {internalError && (<MDBAlert
                open
                className="alert-center"
                color="danger"
                autohide
                position="bottom-right"
                delay={5000}
            >Internal Server Error</MDBAlert>)}
            <div>
                <span className="phrecording">{t("RemoveSndRecFaxtxt")}</span>
            </div>
            <MDBModalFooter>
                <MDBBtn color="secondary" onClick={props.onClose}>
                    {t("cancel")}
                </MDBBtn>
                <MDBBtn onClick={(e) => removeThisFax(e)}>{t("remove")}</MDBBtn>
            </MDBModalFooter>
            {isloading && (
                <>
                    <div className="loadingclass">
                        <MDBBtn disabled>
                            <MDBSpinner size="sm" role="status" tag="span" className="me-2" />
                            Loading...
                        </MDBBtn>
                    </div>
                </>
            )}
        </>
    );
}

export default DeleteSntRecFax;
